/* eslint-disable func-names */
import { Cloudinary } from 'cloudinary-core';
import EXIF from 'exif-js';
import _ from 'lodash';

import { getBasicDeviceInfo, getLocation } from './device';

export const getCloudinaryUrl = (publicId, options) => {
  const cl = Cloudinary.new({ cloud_name: process.env.CLOUDINARY_NAME });
  return cl.url(publicId, options);
};

export const getCloudinaryUrls = (publicIds, options) => {
  const cl = Cloudinary.new({ cloud_name: process.env.CLOUDINARY_NAME });
  return publicIds.map(publicId => cl.url(publicId, options));
};

/**
 * @param {File} file
 */
export const getImageExif = file =>
  new Promise(resolve => {
    EXIF.getData(file, function() {
      const exif = EXIF.getAllTags(this);
      resolve(exif);
    });
  });

/**
 * @param {File} file
 * @param {String} tag
 */
export const getImageExifTag = (file, tag) =>
  new Promise(resolve => {
    EXIF.getData(file, function() {
      const exifTag = EXIF.getTag(this, tag);
      resolve(exifTag);
    });
  });

const parseExifLocationToString = locationObject => {
  try {
    return (
      locationObject[0].numerator +
      locationObject[1].numerator / (60 * locationObject[1].denominator) +
      locationObject[2].numerator / (3600 * locationObject[2].denominator)
    );
  } catch (e) {
    return null;
  }
};

/**
 * @param {Object} exif
 * @return {Object}
 */
const getExifLocation = exif => {
  const { GPSLatitude, GPSLongitude } = exif;
  if (!_.isEmpty(GPSLatitude) && !_.isEmpty(GPSLongitude)) {
    const latitude = parseExifLocationToString(GPSLatitude);
    const longitude = parseExifLocationToString(GPSLongitude);
    if (latitude && longitude) {
      return {
        latitude,
        longitude,
      };
    }
  }

  return null;
};

/**
 * @param {File} file
 * @return {Object}
 */
export const getImageSourceInfo = file =>
  new Promise(resolve => {
    getImageExif(file).then(exif => {
      const exifLocation = getExifLocation(exif);

      const info = {
        exif,
        source_information: getBasicDeviceInfo(),
        type_photo_source: 'web',
        type_platform: 'web',
      };

      if (!_.isEmpty(exifLocation)) {
        resolve({
          ...info,
          ...exifLocation,
        });
      } else {
        getLocation()
          .then(position => {
            const latitude = _.get(position, 'coords.latitude');
            const longitude = _.get(position, 'coords.longitude');
            resolve({
              ...info,
              latitude,
              longitude,
            });
          })
          .catch(() => {
            resolve(info);
          });
      }
    });
  });

/**
 * @param {File} file
 * @return {Boolean}
 */
export const isImageFile = file => {
  const fileType = _.get(file, 'type');

  return fileType ? _.isEqual(_.first(_.split(fileType, '/')), 'image') : false;
};
